/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
import { Typography, Tooltip, Box } from '@material-ui/core'
import React from 'react'
import useStyles from './styles'

type Props = {
  title: string
  tooltipIndex?: number | null
  tooltipText?: string
  tooltipWordColor?: string
  numTooltipWords?: number
}

const splitWordsAtIndex = (
  titleArray: string[],
  tooltipIndex: number,
  numTooltipWords: number
) => {
  const wordsBefore = titleArray.slice(0, tooltipIndex).join(' ')
  const wordsAfter = titleArray.slice(tooltipIndex + numTooltipWords).join(' ')

  return [wordsBefore, wordsAfter]
}

const TitleWithTooltipSong = ({
  title,
  tooltipIndex,
  tooltipText,
  tooltipWordColor,
  numTooltipWords = 1,
}: Props) => {
  const classes = useStyles()
  const DOMPurify = require('dompurify')(window)

  if (tooltipIndex === null || tooltipIndex === undefined) {
    return (
      <Box mb='10px'>
        <Typography
          variant='h6'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
        />
      </Box>
    )
  }

  const titleArray = title.split(' ')
  const [wordsBefore, wordsAfter] = splitWordsAtIndex(
    titleArray,
    tooltipIndex,
    numTooltipWords
  )
  const tooltipClass =
    tooltipIndex === titleArray.length - 2 &&
    ['?', '.'].includes(title.slice(-1))
      ? `${classes.tooltipWord} ${classes.tooltipLastWord}`
      : tooltipIndex === 0
      ? `${classes.tooltipWord} ${classes.tooltipFirstWord}`
      : `${classes.tooltipWord}`

  return (
    <Box mb='10px'>
      <Typography variant='h6' display='inline'>
        {wordsBefore}
      </Typography>
      {tooltipText && (
        <Tooltip
          title={
            <Typography
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(tooltipText),
              }}
              display='inline'
            />
          }
        >
          <Typography
            className={tooltipClass}
            variant='h6'
            display='inline'
            style={{ color: tooltipWordColor }}
          >
            {titleArray
              .slice(tooltipIndex, tooltipIndex + numTooltipWords)
              .join(' ')}
          </Typography>
        </Tooltip>
      )}
      <Typography variant='h6' display='inline'>
        {wordsAfter}
      </Typography>
    </Box>
  )
}

TitleWithTooltipSong.defaultProps = {
  tooltipIndex: null,
  tooltipText: null,
  tooltipWordColor: undefined,
  numTooltipWords: 1,
}

export default TitleWithTooltipSong
